import { Checkbox, makeStyles } from "@fluentui/react-components";
import { UseFormRegisterReturn } from "react-hook-form";
import LabelWithInfoIcon from "../common/LabelWithInfoIcon";
import {
  GENERATE_APPLICATION_CHECKBOX_LABEL,
  GENERATE_APPLICATION_CHECKBOX_TOOLTIP,
} from "../../utils/linkedCompensation";

interface GenerateApplicationCheckboxProps {
  formHandler: UseFormRegisterReturn;
  checked?: boolean;
  disabled?: boolean;
}

const useStyles = makeStyles({
  row: {
    display: "flex",
    alignItems: "center",
    columnGap: "8px",
  },
});

export default function GenerateApplicationCheckbox({
  formHandler,
  checked,
  disabled,
}: GenerateApplicationCheckboxProps) {
  const styles = useStyles();

  return (
    <div className={styles.row}>
      <Checkbox
        label={GENERATE_APPLICATION_CHECKBOX_LABEL}
        {...formHandler}
        {...(checked !== undefined ? { checked } : {})}
        disabled={disabled}
      />
      <LabelWithInfoIcon info={GENERATE_APPLICATION_CHECKBOX_TOOLTIP} />
    </div>
  );
}
